<template>
  <div>
    <TitleWrapper :title="currentRoute.name" :display-breadcrumb="true" />
    <NoRecordFound :text="noRecordFoundText" />
  </div>
</template>

<script>
import TitleWrapper from '@components/TitleWrapper.vue'
import NoRecordFound from '@/src/components/BaseComponent/NoRecordFound.vue'
import { useBlinkField, BLINK_KEYS } from '@src/utils/layoutUtils.js'
import { mapActions, mapGetters } from 'vuex'
import { SCOPE_LEVELS } from '@src/constants/general-constants.js'
import { pluralToSingular } from '@/src/utils/generalUtil'
export default {
  name: 'DefaultPreview',
  components: { TitleWrapper, NoRecordFound },

  props: {
    currentRoute: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      noRecordFoundText: 'NO_RECORD_FOUND',
    }
  },
  computed: {
    ...mapGetters('featureNaming', ['sectionName', 'className']),
  },
  watch: {
    currentRoute: {
      immediate: true,
      deep: true,
      handler(newRoute) {
        this.getLevel(newRoute.basedOn)
      },
    },
  },
  methods: {
    pluralToSingular,
    getLevel(basedOn = []) {
      const blink = (key, text) => {
        this.setRightbarContent(null)
        this.noRecordFoundText = text
        const fieldBlink = useBlinkField?.(key)
        if (fieldBlink) fieldBlink.startBlink()
        const noRecordBlink = useBlinkField?.(BLINK_KEYS.NO_RECORD)
        if (noRecordBlink) noRecordBlink.startBlink()
      }

      switch (true) {
        case !basedOn.length || basedOn.includes(SCOPE_LEVELS.ROOT_LEVEL):
          return 'isRootLevel'

        case basedOn.includes(SCOPE_LEVELS.CAMPUS_LEVEL):
          blink(BLINK_KEYS.CAMPUS, 'PLEASE_SELECT_A_CAMPUS')
          return 'isCampusLevel'

        case basedOn.includes(SCOPE_LEVELS.CLASS_LEVEL):
          blink(BLINK_KEYS.CLASS, `PLEASE_SELECT_A_${pluralToSingular(this.className)}`)
          return 'isClassLevel'

        case basedOn.includes(SCOPE_LEVELS.SECTION_LEVEL):
          blink(BLINK_KEYS.SECTION, `PLEASE_SELECT_A_${pluralToSingular(this.sectionName)}`)
          return 'isSectionLevel'

        default:
          return null
      }
    },

    ...mapActions('layout', ['setRightbarContent']),
  },
}
</script>
